import { ReactElement } from "react";
import { ElementProps } from "../../functionalComponents/RenderPage";

const StackName = function({}: ElementProps): ReactElement<ElementProps> {
  return <></>; // taken care of by SSR
};

export default StackName;
